import React, {useEffect, useMemo} from 'react';
import {DropdownField} from '@components';
import {Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {COUNTRIES_LIST} from '@app/utils/constants';
import moment from 'moment';
import {useFormikContext} from 'formik';
import {GreenButton} from '@styled';
import {sagaActions} from './redux/saga';

const OwnerDashboardFilters = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const {resetForm} = useFormikContext();

  const filtersData = useSelector((state) => state.dashboard.filtersData);

  const {
    SECTOR_OPTIONS,
    SOURCE_CATEGORIES,
    EMISSION_SOURCES,
    FUEL_TYPES,
    REPORT_YEAR_OPTIONS,
  } = useMemo(() => {
    let sectors = [];
    let sCategories = [];
    let eSources = [];
    let fTypes = [];
    const rYears = [];

    for (let i = Number(moment().format('YYYY')); i >= 1970; i -= 1) {
      rYears.push({label: i, value: i});
    }

    if (filtersData) {
      sectors = (filtersData.sectors || []).map((sector) => ({
        label: sector.sector,
        value: sector.sectorCode,
      }));
      sCategories = (filtersData.sourceCategories || []).map((category) => ({
        label: category.name,
        value: category.id,
      }));
      eSources = (filtersData.emissionSources || []).map((source) => ({
        label: source.name,
        value: source.id,
        categoryId: source.categoryId,
      }));
      fTypes = (filtersData.fuelTypes || []).map((fType) => ({
        label: fType,
        value: fType,
      }));
    }

    return {
      SECTOR_OPTIONS: [{label: 'All', value: ''}, ...sectors],
      SOURCE_CATEGORIES: [{label: 'All', value: ''}, ...sCategories],
      EMISSION_SOURCES: [{label: 'All', value: ''}, ...eSources],
      FUEL_TYPES: [{label: 'All', value: ''}, ...fTypes],
      REPORT_YEAR_OPTIONS: rYears,
    };
  }, [filtersData]);

  useEffect(() => {
    // fetch dashboard filters;
    // after load apply by reading from query param
    dispatch({type: sagaActions.FETCH_OWNER_DASHBOARD_FILTERS, payload: {}});
  }, []);

  const handleFilterChange = (val, filterType) => {
    console.log('Filter change', val, filterType);
  };

  const handleResetFilters = () => {
    resetForm();
  };

  return (
    <>
      <div>
        <Row>
          <Col>&#160;</Col>
          <Col className="text-right">
            <GreenButton type="button" className="mr-2">
              Export Data
            </GreenButton>
            <GreenButton
              type="button"
              className="mr-2"
              onClick={handleResetFilters}
            >
              Reset Filters
            </GreenButton>
          </Col>
        </Row>
      </div>
      <div className="card p-3 mt-2">
        <Row>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.reportYear')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="reportYear"
                  name="reportYear"
                  label=""
                  options={REPORT_YEAR_OPTIONS}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'REPORT_YEAR')}
                />
              </div>
            </div>
          </Col>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.reportSector')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="reportSector"
                  name="reportSector"
                  label=""
                  options={SECTOR_OPTIONS}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'SECTOR')}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.sourceCategory')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="sourceCategory"
                  name="sourceCategory"
                  label=""
                  options={SOURCE_CATEGORIES}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'SOURCE_CATEGORY')}
                />
              </div>
            </div>
          </Col>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.emissionSource')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="emissionSource"
                  name="emissionSource"
                  label=""
                  options={EMISSION_SOURCES}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'EMISSION_SOURCE')}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.fuelType')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="fuelType"
                  name="fuelTYpe"
                  label=""
                  options={FUEL_TYPES}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'FUEL_TYPE')}
                />
              </div>
            </div>
          </Col>
          <Col>
            <div className="d-flex flex-row justify-content-end align-items-center text-left">
              <span className="pr-3 mb-3" style={{flex: 0.5}}>
                {t('owner.dashboard.filters.country')}
              </span>
              <div style={{flex: 1}}>
                <DropdownField
                  id="country"
                  name="country"
                  label=""
                  options={COUNTRIES_LIST}
                  placeholder="--select--"
                  menuPortalTarget="parent"
                  onChange={(val) => handleFilterChange(val, 'COUNTRY')}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OwnerDashboardFilters;
